import type { OutcomeMetric, WorkflowStep } from '@/types/meet-live-ai';

export const WORKFLOW_STEPS: WorkflowStep[] = [
  {
    number: '01',
    title: 'Connect',
    description:
      'Connect enterprise data silos, live systems, and key operational sources.',
    iconType: 'connect',
  },
  {
    number: '02',
    title: 'Analyze',
    description:
      'Extract multi-file patterns, risk signals, and key document anomalies.',
    iconType: 'analyze',
  },
  {
    number: '03',
    title: 'Recommend',
    description:
      'Generate grounded action plans, decision paths, and verifiable insights.',
    iconType: 'recommend',
  },
  {
    number: '04',
    title: 'Transform',
    description:
      'Execute autonomous workflows, sync operations, and accelerate outcomes.',
    iconType: 'transform',
  },
];

export const OUTCOME_METRICS: OutcomeMetric[] = [
  {
    value: '24.8%',
    direction: 'up',
    label: 'Improvement in recovery rates',
  },
  {
    value: '31%',
    direction: 'down',
    label: 'Reduction in manual effort',
  },
  {
    value: '8x',
    direction: 'up',
    label: 'ROI on automation initiatives',
  },
];
